
import { processingRessponse } from './processingRessponse'
import { repeatedRequestIndex } from './repeatedRequestIndex'
import { getPage } from "./getPage";

export const routerIndex = (data) => {
  switch (data.processing) {
    case 'validating':
      console.log('status: validating')
      setTimeout(function () {
        repeatedRequestIndex()
      }, 3000)
      break
    case 'in_process':
      console.log('status: in_process')
      setTimeout(function () {
        repeatedRequestIndex()
      }, 3000)
      break
    case 'success':
      console.log('status: success')
      processingRessponse(data.processing, data.profile.product)
      break
    case 'retry':
      window.location.href = getPage('cart');
      break
  }
}
